/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AtypicalInputs */

const cs_enum_atypical = /** @type {(inputs: Enum_AtypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atypický`)
};

const en_enum_atypical = /** @type {(inputs: Enum_AtypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atypical`)
};

/**
* | output |
* | --- |
* | "Atypical" |
*
* @param {Enum_AtypicalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_atypical = /** @type {((inputs?: Enum_AtypicalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AtypicalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_atypical(inputs)
	return cs_enum_atypical(inputs)
});